/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountDetails,
  ChangeContactDetailsRequestBody,
  ChangeContactPermissionsRequestBody,
  ChangePasswordRequestBody,
} from '../models/index';
import {
    AccountDetailsFromJSON,
    AccountDetailsToJSON,
    ChangeContactDetailsRequestBodyFromJSON,
    ChangeContactDetailsRequestBodyToJSON,
    ChangeContactPermissionsRequestBodyFromJSON,
    ChangeContactPermissionsRequestBodyToJSON,
    ChangePasswordRequestBodyFromJSON,
    ChangePasswordRequestBodyToJSON,
} from '../models/index';

export interface ChangeContactDetailsRequest {
    changeContactDetailsRequestBody: ChangeContactDetailsRequestBody;
}

export interface ChangeContactPermissionsRequest {
    changeContactPermissionsRequestBody: ChangeContactPermissionsRequestBody;
}

export interface ChangePasswordRequest {
    changePasswordRequestBody: ChangePasswordRequestBody;
}

/**
 * 
 */
export class AccountResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for changeContactDetails without sending the request
     */
    async changeContactDetailsRequestOpts(requestParameters: ChangeContactDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['changeContactDetailsRequestBody'] == null) {
            throw new runtime.RequiredError(
                'changeContactDetailsRequestBody',
                'Required parameter "changeContactDetailsRequestBody" was null or undefined when calling changeContactDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/account/changeContactDetails`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeContactDetailsRequestBodyToJSON(requestParameters['changeContactDetailsRequestBody']),
        };
    }

    /**
     */
    async changeContactDetailsRaw(requestParameters: ChangeContactDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.changeContactDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async changeContactDetails(requestParameters: ChangeContactDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.changeContactDetailsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for changeContactPermissions without sending the request
     */
    async changeContactPermissionsRequestOpts(requestParameters: ChangeContactPermissionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['changeContactPermissionsRequestBody'] == null) {
            throw new runtime.RequiredError(
                'changeContactPermissionsRequestBody',
                'Required parameter "changeContactPermissionsRequestBody" was null or undefined when calling changeContactPermissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/account/changeContactPermissions`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeContactPermissionsRequestBodyToJSON(requestParameters['changeContactPermissionsRequestBody']),
        };
    }

    /**
     */
    async changeContactPermissionsRaw(requestParameters: ChangeContactPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.changeContactPermissionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async changeContactPermissions(requestParameters: ChangeContactPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.changeContactPermissionsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for changePassword without sending the request
     * @deprecated
     */
    async changePasswordRequestOpts(requestParameters: ChangePasswordRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['changePasswordRequestBody'] == null) {
            throw new runtime.RequiredError(
                'changePasswordRequestBody',
                'Required parameter "changePasswordRequestBody" was null or undefined when calling changePassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/account/changePassword`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordRequestBodyToJSON(requestParameters['changePasswordRequestBody']),
        };
    }

    /**
     * @deprecated
     */
    async changePasswordRaw(requestParameters: ChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const requestOptions = await this.changePasswordRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * @deprecated
     */
    async changePassword(requestParameters: ChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.changePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAccountDetails without sending the request
     */
    async getAccountDetailsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/account`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAccountDetailsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountDetails>> {
        const requestOptions = await this.getAccountDetailsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountDetailsFromJSON(jsonValue));
    }

    /**
     */
    async getAccountDetails(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountDetails> {
        const response = await this.getAccountDetailsRaw(initOverrides);
        return await response.value();
    }

}
